import { LogIn, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/components/AuthCallback";

export function AuthButton({ user, onLogout }) {
  const { login, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    onLogout();
  };

  if (user) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-8 px-2 gap-2 text-[#BEF264] hover:text-[#BEF264] hover:bg-[#BEF264]/10"
            data-testid="user-menu-btn"
          >
            {user.picture ? (
              <img 
                src={user.picture} 
                alt={user.name} 
                className="w-5 h-5 rounded-full"
              />
            ) : (
              <User className="w-4 h-4" />
            )}
            <span className="font-mono text-[10px] tracking-wider hidden sm:inline max-w-[80px] truncate">
              {user.name?.split(' ')[0]?.toUpperCase() || user.email?.split('@')[0]?.toUpperCase()}
            </span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-[#0A0A0A] border-[#262626]">
          <DropdownMenuItem className="font-mono text-[11px] text-[#737373] focus:bg-transparent cursor-default">
            {user.email}
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={handleLogout}
            className="font-mono text-[11px] text-[#EF4444] focus:text-[#EF4444] focus:bg-[#EF4444]/10 cursor-pointer"
            data-testid="logout-btn"
          >
            <LogOut className="w-3 h-3 mr-2" />
            Cerrar Sesion
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <Button 
      variant="ghost" 
      size="sm" 
      className="h-8 px-3 gap-2 text-white hover:text-[#BEF264] hover:bg-[#BEF264]/10 border border-[#262626] hover:border-[#BEF264]"
      onClick={login}
      data-testid="login-btn"
    >
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      <span className="font-mono text-[10px] tracking-wider hidden sm:inline">ENTRAR CON GOOGLE</span>
      <span className="font-mono text-[10px] tracking-wider sm:hidden">ENTRAR</span>
    </Button>
  );
}
